<!-- Create Recipient Modal -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50"
  *ngIf="showCreateModal"
>
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-lg font-semibold text-gray-900">Create Recipient</h2>
      <button (click)="closeCreateModal()" class="text-gray-400 hover:text-gray-600">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 01-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.586 10 3.636 5.05a1 1 0 111.414-1.414L10 8.586z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>

    <form (ngSubmit)="createRecipient()" #recipientForm="ngForm" class="space-y-4 max-h-[75vh] overflow-y-auto pr-2">

      <!-- First & Last Name -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">First Name</label>
          <input type="text" name="first_name" [(ngModel)]="newRecipient.first_name"
            #firstName="ngModel" required
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': firstName.invalid && firstName.touched}" />
          <p *ngIf="firstName.invalid && firstName.touched" class="text-xs text-red-500 mt-1">
            First name is required.
          </p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Last Name</label>
          <input type="text" name="last_name" [(ngModel)]="newRecipient.last_name"
            #lastName="ngModel" required
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': lastName.invalid && lastName.touched}" />
          <p *ngIf="lastName.invalid && lastName.touched" class="text-xs text-red-500 mt-1">
            Last name is required.
          </p>
        </div>
      </div>

      <!-- IBAN -->
      <div>
        <label class="block text-sm font-medium text-gray-700">IBAN</label>
        <input type="text" name="iban" [(ngModel)]="newRecipient.iban"
          #iban="ngModel" required minlength="15" maxlength="34"
          class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
          [ngClass]="{'border-red-500': iban.invalid && iban.touched}" />
        <p *ngIf="iban.errors?.['required'] && iban.touched" class="text-xs text-red-500 mt-1">
          IBAN is required.
        </p>
        <p *ngIf="(iban.errors?.['minlength'] || iban.errors?.['maxlength']) && iban.touched" class="text-xs text-red-500 mt-1">
          IBAN must be between 15 and 34 characters.
        </p>
      </div>

      <!-- BIC -->
      <div>
        <label class="block text-sm font-medium text-gray-700">BIC</label>
        <input type="text" name="bic" [(ngModel)]="newRecipient.bic"
          #bic="ngModel" required minlength="8" maxlength="11"
          class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
          [ngClass]="{'border-red-500': bic.invalid && bic.touched}" />
        <p *ngIf="bic.errors?.['required'] && bic.touched" class="text-xs text-red-500 mt-1">
          BIC is required.
        </p>
        <p *ngIf="(bic.errors?.['minlength'] || bic.errors?.['maxlength']) && bic.touched" class="text-xs text-red-500 mt-1">
          BIC must be 8 or 11 characters.
        </p>
      </div>

      <!-- Address -->
      <div>
        <label class="block text-sm font-medium text-gray-700">Street Line 1</label>
        <input type="text" name="street_line_1" [(ngModel)]="newRecipient.street_line_1"
          #street="ngModel" required
          class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
          [ngClass]="{'border-red-500': street.invalid && street.touched}" />
        <p *ngIf="street.invalid && street.touched" class="text-xs text-red-500 mt-1">
          Street address is required.
        </p>
      </div>

      <!-- City & State -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">City</label>
          <input type="text" name="city" [(ngModel)]="newRecipient.city"
            #city="ngModel" required
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': city.invalid && city.touched}" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">State</label>
          <input type="text" name="state" [(ngModel)]="newRecipient.state"
            #state="ngModel" required
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': state.invalid && state.touched}" />
        </div>
      </div>

      <!-- Country & Postal -->
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700">Country (2 letters, e.g. FR)</label>
          <input type="text" name="country" [(ngModel)]="newRecipient.country"
            #country="ngModel" required maxlength="2"
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 uppercase focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': country.invalid && country.touched}" />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700">Postal Code</label>
          <input type="text" name="postal_code" [(ngModel)]="newRecipient.postal_code"
            #postal="ngModel" required pattern="^[0-9A-Za-z\- ]+$"
            class="mt-1 block w-full border border-gray-300 rounded-md p-2 focus:ring-indigo-500 focus:border-indigo-500"
            [ngClass]="{'border-red-500': postal.invalid && postal.touched}" />
        </div>
      </div>

      <!-- Actions -->
      <div class="mt-6 flex justify-end gap-3 border-t border-gray-200 pt-4">
        <button type="button" (click)="closeCreateModal()"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200">
          Cancel
        </button>
        <button type="submit"
          class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md hover:bg-indigo-500 disabled:opacity-50"
          [disabled]="recipientForm.invalid">
          Save
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Loader -->
<div class="flex items-center justify-center h-64" *ngIf="loading">
  <svg class="animate-spin h-8 w-8 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4z"></path>
  </svg>
</div>

<!-- Main Table -->
<div *ngIf="!loading">
  <div class="sm:flex sm:items-center">
    <div class="sm:flex-auto">
      <h1 class="text-2xl font-semibold text-gray-900">SEPA Recipients</h1>
    </div>
    <div class="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
      <button type="button" (click)="openCreateModal()"
        class="inline-flex items-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500">
        + Create Recipient
      </button>
    </div>
  </div>

  <div class="mt-8 overflow-x-auto shadow rounded-lg">
    <table class="min-w-full divide-y divide-gray-300 bg-white">
      <thead class="bg-gray-50">
        <tr>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">First name</th>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Last name</th>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">IBAN</th>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">BIC</th>
          <th class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Created At</th>
        </tr>
      </thead>
      <tbody class="divide-y divide-gray-200">
        <tr *ngFor="let recipient of recipients" class="hover:bg-gray-50">
          <td class="px-3 py-3 text-sm text-gray-700">{{ recipient.first_name }}</td>
          <td class="px-3 py-3 text-sm text-gray-700">{{ recipient.last_name }}</td>
          <td class="px-3 py-3 text-sm text-gray-700">{{ recipient.iban }}</td>
          <td class="px-3 py-3 text-sm text-gray-700">{{ recipient.bic }}</td>
          <td class="px-3 py-3 text-sm text-gray-700">{{ recipient.created_at | date : 'medium' }}</td>
        </tr>
      </tbody>
    </table>

    <ng-template #noRecipients>
      <div class="text-center py-10 text-gray-500">
        <p>No recipients found.</p>
      </div>
    </ng-template>
  </div>

  <!-- Pagination -->
  <div class="mt-6 flex justify-center">
    <nav class="inline-flex rounded-md shadow-sm">
      <button (click)="goToPreviousPage()" [disabled]="!previousPageUrl"
        class="px-3 py-2 border border-gray-300 rounded-l-md bg-white text-sm hover:bg-gray-50 disabled:opacity-50">
        ‹
      </button>
      <button *ngFor="let page of pageNumbers"
        (click)="page !== '...' && loadRecipients(page)"
        [disabled]="page === '...' || currentPage === page"
        [ngClass]="{
          'bg-indigo-600 text-white': currentPage === page,
          'bg-white text-gray-700': currentPage !== page
        }"
        class="px-4 py-2 border border-gray-300 text-sm hover:bg-gray-50">
        {{ page }}
      </button>
      <button (click)="goToNextPage()" [disabled]="!nextPageUrl"
        class="px-3 py-2 border border-gray-300 rounded-r-md bg-white text-sm hover:bg-gray-50 disabled:opacity-50">
        ›
      </button>
    </nav>
  </div>
</div>
